import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../lib/api';

export const askQuestion = createAsyncThunk(
  'chat/ask',
  async (question, { getState }) => {
    const { email } = getState().chat;
    const res = await api.post('/chat/', { question, email });
    return {
      question,
      answer: res.data.answer,
      chat_id: res.data.chat_id,
    };
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    history: [],
    email: localStorage.getItem('chat_email') || '',
    guest_name: localStorage.getItem('guest_name') || `Guest-${Math.random().toString(36).substring(2, 8)}`,
    loading: false,
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
      localStorage.setItem('chat_email', action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(askQuestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(askQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.history.push({ sender: 'user', text: action.payload.question });
        state.history.push({
          sender: 'bot',
          text: '',
          fullText: action.payload.answer,
          chat_id: action.payload.chat_id,
        });
      })
      .addCase(askQuestion.rejected, (state) => {
        state.loading = false;
        state.history.push({ sender: 'bot', text: '❌ Sorry, something went wrong.' });
      });
  },
});

export const { setEmail } = chatSlice.actions;
export default chatSlice.reducer;
